
export class UIGameMapViewLayers {
    readonly bottomLayer: number = 0
    readonly mapTiles: number = 1
    readonly ports: number = 2
    readonly pirate: number = 3
    readonly mapEdgePieces: number = 4
    readonly mapCityWall: number = 5
    readonly mapCornerPieces: number = 6
    readonly mapCornerKnightPieces: number = 7
    readonly robber: number = 8
    readonly metropolis: number = 9
    readonly chits: number = 10
    readonly topLayer: number = 11
    readonly informationPopups: number = 12
}
